export default __webpack_public_path__ + "static/media/Group9264.e23ce4da.svg";